import { ArrowLeft, Check } from "lucide-react";
import styles from "./scriptFlow.module.scss";

const STEPS = ["Profile", "Analysis", "Brief", "Script"] as const;

export function scriptFlowStep({
  analyzing,
  failed,
  hasAnalysis,
  writingScript,
}: {
  analyzing: boolean;
  failed: boolean;
  hasAnalysis: boolean;
  writingScript: boolean;
}): 1 | 2 | 3 | 4 {
  if (writingScript) return 4;
  if (analyzing || failed || !hasAnalysis) return 2;
  return 3;
}

export function ScriptFlowHeader({
  creatorName,
  current,
  scriptReady,
  onBack,
}: {
  creatorName: string;
  current: 1 | 2 | 3 | 4;
  scriptReady: boolean;
  onBack: () => void;
}) {
  return (
    <header className={styles.header}>
      <div className={styles.head}>
        <button type="button" className={styles.back} onClick={onBack}>
          <ArrowLeft size={14} /> All creators
        </button>
        <p className={styles.name}>{creatorName}</p>
      </div>
      <ol className={styles.steps} aria-label="Progress">
        {STEPS.map((label, index) => {
          const number = (index + 1) as 1 | 2 | 3 | 4;
          const done = number < current || (number === 4 && scriptReady);
          const active = number === current;
          return (
            <li key={label} className={styles.step}>
              {index > 0 ? (
                <span
                  className={`${styles.line} ${
                    done || active ? styles.lineActive : ""
                  }`}
                />
              ) : null}
              <span
                className={`${styles.mark} ${
                  done ? styles.markDone : active ? styles.markCurrent : ""
                }`}
              >
                {done ? <Check size={11} strokeWidth={3} /> : number}
              </span>
              <span
                className={`${styles.label} ${active ? styles.labelCurrent : ""} ${
                  !active && !done ? styles.labelIdle : ""
                }`}
              >
                {label}
              </span>
            </li>
          );
        })}
      </ol>
    </header>
  );
}
